import * as types from './mutations-types'

const mutations = {
  [types.SET_TOKEN] (state, data) {
    state.token = data
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js